import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ProtectedRoute = ({ element, children }) => {
  const { token } = useAuth();

  // Check token in localStorage as a fallback for persistence
  const storedToken = token || localStorage.getItem('token');

  // Redirect to the login page if the user is not authenticated
  if (!storedToken) {
    return <Navigate to="/" replace />;
  }

  // Render the protected content (element, children, or Outlet for nested routes)
  return element || children || <Outlet />;
};

export default ProtectedRoute;
